import { Box } from '@mui/material';
import { ElementType } from 'react';
import { Outlet } from 'react-router-dom';

const LayoutAdapter = ({ Layout }: { Layout: ElementType }) => (
  <Box component={Layout}>
    <Outlet />
  </Box>
);

export default LayoutAdapter;
